module.exports = __webpack_public_path__ + "img/special_bihakulotion.0c831c5a.jpg";